export default "__VITE_ASSET__DfEobMvJ__"